import React from 'react';
import ApiSauce, { CancelToken, ApiResponse } from 'apisauce';
import ApiConfig from '../../services/config/ApiConfig';
import "./summary.module.css"
import Table1, { Table1Data } from './SummaryTables/Table1';
import Table2, { Table2Data } from './SummaryTables/Table2';
import Table3a, { Table3aData } from './SummaryTables/Table3a';
import Table3b, { Table3bData } from './SummaryTables/Table3b';
import Table4, { Table4Data } from './SummaryTables/Table4';
import Table5, { Table5Data } from './SummaryTables/Table5';
import Table6, { Table6Data } from './SummaryTables/Table6';
import Table7, { Table7Data } from './SummaryTables/Table7';
import Table8a, { Table8aData } from './SummaryTables/Table8a';
import Table8b, { Table8bData } from './SummaryTables/Table8b';
import Table9a, { Table9aData } from './SummaryTables/Table9a';
import Table9b1, { Table9b1Data } from './SummaryTables/Table9b1';
import Table9b2, { Table9b2Data } from './SummaryTables/Table9b2';
import Table10, { Table10Data } from './SummaryTables/Table10';
import Table11a, { Table11aData } from './SummaryTables/Table11a';
import Table11b, { Table11bData } from './SummaryTables/Table11b';
import Table12a, { Table12aData } from './SummaryTables/Table12a';
import Table12b, { Table12bData } from './SummaryTables/Table12b';
import Table12c, { Table12cData } from './SummaryTables/Table12c';
import Table13a, { Table13aData } from './SummaryTables/Table13a';
import Table13b, { Table13bData } from './SummaryTables/Table13b';
import Table14, { Table14Data } from './SummaryTables/Table14';
import Table15, { Table15Data } from './SummaryTables/Table15';
import Table16, { Table16Data } from './SummaryTables/Table16';
import Table17, { Table17Data } from './SummaryTables/Table17';
import Table18, { Table18Data } from './SummaryTables/Table18';
import Table19a, { Table19aData } from './SummaryTables/Table19a';
import Table19b, { Table19bData } from './SummaryTables/Table19b';
import Table20, { Table20Data } from './SummaryTables/Table20';
import Table21, { Table21Data } from './SummaryTables/Table21';
import { IStandardSummaryRequest, StandardSummaryGrouping } from './common';
const ndot_logo = require('../../assets/ndor_logo.png');

const api = ApiSauce.create({
  ...ApiConfig,
  cancelToken: CancelToken.source().token,
});

export interface IStandardSummaryProps {
  partId: number;
  ssRequest: IStandardSummaryRequest;
  apiToken: string;
}

interface IStandardSummaryState {
  table1Data: Table1Data;
  table2Data: Table2Data;
  table3aData: Table3aData;
  table3bData: Table3bData;
  table4Data: Table4Data;
  table5Data: Table5Data;
  table6Data: Table6Data;
  table7Data: Table7Data;
  table8aData: Table8aData;
  table8bData: Table8bData;
  table9aData: Table9aData;
  table9b1Data: Table9b1Data;
  table9b2Data: Table9b2Data;
  table10Data: Table10Data;
  table11aData: Table11aData;
  table11bData: Table11bData;
  table12aData: Table12aData;
  table12bData: Table12bData;
  table12cData: Table12cData;
  table13aData: Table13aData;
  table13bData: Table13bData;
  table14Data: Table14Data;
  table15Data: Table15Data;
  table16Data: Table16Data;
  table17Data: Table17Data;
  table18Data: Table18Data;
  table19aData: Table19aData;
  table19bData: Table19bData;
  table20Data: Table20Data;
  table21Data: Table21Data;
  tablesWithData: { [key: string]: boolean };
}

const initialState: IStandardSummaryState = {
  table1Data: null,
  table2Data: null,
  table3aData: null,
  table3bData: null,
  table4Data: null,
  table5Data: null,
  table6Data: null,
  table7Data: null,
  table8aData: null,
  table8bData: null,
  table9aData: null,
  table9b1Data: null,
  table9b2Data: null,
  table10Data: null,
  table11aData: null,
  table11bData: null,
  table12aData: null,
  table12bData: null,
  table12cData: null,
  table13aData: null,
  table13bData: null,
  table14Data: null,
  table15Data: null,
  table16Data: null,
  table17Data: null,
  table18Data: null,
  table19aData: null,
  table19bData: null,
  table20Data: null,
  table21Data: null,
  tablesWithData: {
    table1: false,
    table2: false,
    table3a: false,
    table3b: false,
    table4: false,
    table5: false,
    table6: false,
    table7: false,
    table8a: false,
    table8b: false,
    table9a: false,
    table9b1: false,
    table9b2: false,
    table10: false,
    table11a: false,
    table11b: false,
    table12a: false,
    table12b: false,
    table12c: false,
    table13a: false,
    table13b: false,
    table14: false,
    table15: false,
    table16: false,
    table17: false,
    table18: false,
    table19a: false,
    table19b: false,
    table20: false,
    table21: false,
  },
};

class StandardSummary extends React.Component<IStandardSummaryProps, IStandardSummaryState> {
  public constructor(props: IStandardSummaryProps) {
    super(props);
    this.state = initialState;

    api.setHeader('Authorization', props.apiToken);
  };

  componentDidMount = () => {
    const partId = this.props.partId;

    const setStateWithResponse = (result) => this.setState({
      table1Data: result.data.table1,
      table2Data: result.data.table2,
      table3aData: result.data.table3a,
      table3bData: result.data.table3b,
      table4Data: result.data.table4,
      table5Data: result.data.table5,
      table6Data: result.data.table6,
      table7Data: result.data.table7,
      table8aData: result.data.table8a,
      table8bData: result.data.table8b,
      table9aData: result.data.table9a,
      table9b1Data: result.data.table9b1,
      table9b2Data: result.data.table9b2,
      table10Data: result.data.table10,
      table11aData: result.data.table11a,
      table11bData: result.data.table11b,
      table12aData: result.data.table12a,
      table12bData: result.data.table12b,
      table12cData: result.data.table12c,
      table13aData: result.data.table13a,
      table13bData: result.data.table13b,
      table14Data: result.data.table14,
      table15Data: result.data.table15,
      table16Data: result.data.table16,
      table17Data: result.data.table17,
      table18Data: result.data.table18,
      table19aData: result.data.table19a,
      table19bData: result.data.table19b,
      table20Data: result.data.table20,
      table21Data: result.data.table21,
      tablesWithData: {
        table1: true,
        table2: true,
        table3a: true,
        table3b: true,
        table4: true,
        table5: true,
        table6: true,
        table7: true,
        table8a: true,
        table8b: true,
        table9a: true,
        table9b1: true,
        table9b2: true,
        table10: true,
        table11a: true,
        table11b: true,
        table12a: true,
        table12b: true,
        table12c: true,
        table13a: true,
        table13b: true,
        table14: true,
        table15: true,
        table16: true,
        table17: true,
        table18: true,
        table19a: true,
        table19b: true,
        table20: true,
        table21: true,
      }
    });

    if (partId) {
      api.post("StandardSummary/GetDataByPartId", { partId })
        .then((result: ApiResponse<any>) => {
          setStateWithResponse(result);
        });
    } else {
      api.post("StandardSummary/GetAllTableData", { ...this.props.ssRequest })
        .then((result: ApiResponse<any>) => {
          setStateWithResponse(result);
        });
    }
  }

  public render() {
    return (
      <React.Fragment>
        <header id='page-header'>
          {(!this.props.ssRequest.grouping || this.props.ssRequest.grouping === StandardSummaryGrouping.YearToDate) &&
            <>
              <div>
                <p>STANDARD SUMMARY OF NEBRASKA</p>
                <p>MOTOR VEHICLE TRAFFIC CRASHES</p>
              </div>
              {!this.props.ssRequest.grouping &&
                <div className="logo">
                  <img
                    src={ndot_logo}
                    alt="Nebraska Department of Roads"
                  />
                </div>
              }
            </>
          }
        </header>
        <div id="sscontent">
          <Table1
            data={this.state.table1Data}
          />
          <Table2
            data={this.state.table2Data}
          />
          <Table3a
            data={this.state.table3aData}
            standardSummaryTypeId={this.props.ssRequest.standardSummaryTypeId}
          />
          <Table3b
            data={this.state.table3bData}
          />
          <Table4
            data={this.state.table4Data}
          />
          <Table5
            data={this.state.table5Data}
          />
          <Table6
            data={this.state.table6Data}
          />
          <Table7
            data={this.state.table7Data}
          />
          <Table8a
            data={this.state.table8aData}
          />
          <Table8b
            data={this.state.table8bData}
          />
          <Table9a
            data={this.state.table9aData}
          />
          <Table9b1
            data={this.state.table9b1Data}
          />
          <Table9b2
            data={this.state.table9b2Data}
          />
          <Table10
            data={this.state.table10Data}
          />
          <Table11a
            data={this.state.table11aData}
          />
          <Table11b
            data={this.state.table11bData}
          />
          <Table12a
            data={this.state.table12aData}
          />
          <Table12b
            data={this.state.table12bData}
          />
          <Table12c
            data={this.state.table12cData}
          />
          <Table13a
            data={this.state.table13aData}
          />
          <Table13b
            data={this.state.table13bData}
          />
          <Table14
            data={this.state.table14Data}
          />
          <Table15
            data={this.state.table15Data}
          />
          <Table16
            data={this.state.table16Data}
          />
          <Table17
            data={this.state.table17Data}
          />
          <Table18
            data={this.state.table18Data}
          />
          <Table19a
            data={this.state.table19aData}
          />
          <Table19b
            data={this.state.table19bData}
          />
          <Table20
            data={this.state.table20Data}
          />
          <Table21
            data={this.state.table21Data}
          />
        </div>

        {Object.values(this.state.tablesWithData).every(v => v === true) && <div id="allDataReceived"></div>}
      </React.Fragment>
    )
  }
}

export default StandardSummary;